import React from 'react'

export default props => (
	<div className='box box-success'>
		<div className='box-header with-border'>
			{props.children}
		</div>
	</div>
)
